// extracted by mini-css-extract-plugin
export var actions = "_bx-d";
export var benefitCard = "_bx-a";
export var benefitIcon = "_bx-b";
export var benefitLabel = "_bx-c";
export var benefits = "_bx-9";
export var bodyText = "_bx-8";
export var closeButton = "_bx-2";
export var content = "_bx-3";
export var eyebrow = "_bx-4";
export var heading = "_bx-5";
export var image = "_bx-f";
export var imagePanel = "_bx-e";
export var modal = "_bx-0";
export var shell = "_bx-1";
export var title = "_bx-6";
export var titleOffer = "_bx-7";